import styled from '@emotion/styled'

export const StyleAvailabilityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
`

export const StyleAvailabilityItems = styled.div`
  display: flex;
  column-gap: 20px;
`
export const StyleAvailabilityItem = styled.div<any>`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props: any) =>
    props?.theme.colors[!!props.isActive ? 'primary' : 'white']};
  p {
    color: ${(props: any) =>
      props?.theme.colors[!!props.isActive ? 'white' : 'text']};
  }
`

export const StyleTimeWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 4px;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  column-gap: 10px;
`
